import { atom } from "jotai";

// A message the chat should bring on screen, by its DB row id. Set when the
// row is not rendered yet, because it sits in a page the chat has not loaded:
// the chat loads earlier pages until the row renders, then highlights it.
export const revealMessageAtom = atom<{
  conversationId: string;
  messageId: string;
} | null>(null);

// Scroll the message into view and flash a transient highlight. Every reply
// carries ``data-db-message-id`` (see NoxusMessageContent); inline styles keep
// the highlight theme-independent. False when the row is not rendered.
export function highlightMessage(
  messageId: string,
  behavior: ScrollBehavior = "smooth"
): boolean {
  const el = document.querySelector(`[data-db-message-id="${messageId}"]`);
  if (!(el instanceof HTMLElement)) return false;
  el.scrollIntoView({ behavior, block: "center" });
  // Neutral, theme-independent grey. The box-shadow spread pads the colour a
  // few px beyond the text without shifting surrounding layout.
  const highlight = "rgba(120, 120, 120, 0.09)";
  el.style.transition = "background-color 0.3s ease, box-shadow 0.3s ease";
  el.style.borderRadius = "8px";
  el.style.backgroundColor = highlight;
  el.style.boxShadow = `0 0 0 10px ${highlight}`;
  window.setTimeout(() => {
    el.style.backgroundColor = "";
    el.style.boxShadow = "";
  }, 1600);
  return true;
}
